require('bootstrap');
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
import  './general.js';
window.$ = window.jQuery = require('jquery');

$(document).ready(function () {

    // search city
    $('#input-search-city').keydown(function (e) {
        if (e.keyCode == 13) {
            $('#button-search-city').trigger('click');
        }
    });
    $('#button-search-city').click(function () {
        let $button = $(this);
        let $input = $button.prev();
        let searchTerm = $input.val();
        if (searchTerm === '') {
            $(".city-container").removeClass('d-none');
        } else {
            $(".city-container").addClass('d-none');
            $(".city-container:contains(" + searchTerm + ")").removeClass('d-none');
        }
    });

    // search mosque
    $('#input-search-mosque').keydown(function (e) {
        if (e.keyCode == 13) {
            $('#button-search-mosque').trigger('click');
        }
    });
    $('#button-search-mosque').click(function () {
        let $button = $(this);
        let $input = $button.prev();
        let searchTerm = $input.val();
        if (searchTerm === '') {
            $(".mosque-container").removeClass('d-none');
        } else {
            $(".mosque-container").addClass('d-none');
            $(".mosque-container:contains(" + searchTerm + ")").removeClass('d-none');
        }
    });

    $('button.add-comment').click(function (e) {
        e.preventDefault();
        $('#comment-success').addClass('d-none');
        $('#comment-form').removeClass('d-none');
        $('.js-add-comment-btn').removeClass('d-none');
        removeJsValidationErrors('#modal-add-comment');

        $('#refresh-captcha').trigger('click');
        let $this = $(this);
        let $modal = $('#modal-add-comment');
        $modal.find('#comment-mosque-id').val($this.closest('.mosque-container').data('mosque-id'));
        let commentModal = new bootstrap.Modal(document.getElementById('modal-add-comment'));
        commentModal.show();
    });

    // add comment
    $('.js-add-comment-btn').click(function () {
        removeJsValidationErrors('#modal-add-comment');
        let $modal = $('#modal-add-comment');
        let data = {
            mosque_id: $modal.find('#comment-mosque-id').val(),
            author_name: $modal.find('#comment-author-name').val(),
            body: $modal.find('#comment-body').val(),
            captcha: $modal.find('#comment-captcha').val(),
        };
        $.post('/comments/' + data.mosque_id + '/store', data, function (response) {
            $('#comment-form').addClass('d-none');
            $('#comment-success').removeClass('d-none');
            $('.js-add-comment-btn').addClass('d-none');
            $modal.find('#comment-author-name').val('');
            $modal.find('#comment-body').val('');
            $modal.find('#comment-captcha').val('');
        }).fail(function (response) {
            console.log(response)
            if (response.status == 422) {
                console.log(response.status)
                showJsValidationErrors('#modal-add-comment', response.responseJSON.errors);
            }
            $('#refresh-captcha').trigger('click');
        });
    });

    // refresh captcha
    $('#refresh-captcha').click(function () {
        let $this = $(this);
        $this.find('i').addClass('spin');
        let strRandom = (Math.random() + 1).toString(36).substring(10);
        let src = '/captcha/default?' + strRandom;
        $('img.captcha').attr('src', src);
        setTimeout(function () {
            $this.find('i').removeClass('spin');
        }, 1000)
    });
});
